import { Typography } from '@mui/material';
import { GridColumnHeaderParams, GridValidRowModel } from '@mui/x-data-grid-premium';

import Hint from '../Hint';

/**
 * Generic over the row model. `GridColumnHeaderParams` defaults to
 * `GridValidRowModel`, and `colDef` puts the row model in a CONTRAVARIANT
 * position (`GridActionsColDef.getActions`), so a header pinned to the default
 * cannot be used by a grid with a typed row model plus an `actions` column.
 * Type-only change — the rendered output is unchanged.
 */
export default function BoldHeader<Row extends GridValidRowModel>(params: GridColumnHeaderParams<Row>) {
  return (
    <Hint title={params.colDef.description}>
      <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{params.colDef.headerName}</Typography>
    </Hint>
  );
}
